import { IconDefinition } from "@fortawesome/pro-light-svg-icons";

import { FileUploadError } from "../enums/file-upload-error.enum";
import { IUploadFile } from "../interfaces/upload-file.interface";

export class UploadFile implements IUploadFile {
  id: string;
  file: File;
  icon: IconDefinition;
  fileSizeInByte: number;
  isProgressing?: boolean;
  errors?: FileUploadError[];

  constructor(props: IUploadFile) {
    this.id = props.id;
    this.file = props.file;
    this.icon = props.icon;
    this.fileSizeInByte = props.fileSizeInByte;
    this.isProgressing = props.isProgressing;
    this.errors = props.errors;
  }
}
